export const routers = [
  /**
   * 默认
   */
   {
    path: '/',
    name: '',
    component: () => import('@/views/common/auth'),
    meta: {
      requiresAuth: true
    }
  },
  /**
   * 首页
   */
  {
    path: '/index',
    name: 'Index',
    component: () => import('@/views/home/index/ServeIndex'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/newsindex',
    name: 'newsIndex',
    component: () => import('@/views/home/index/NewServerIndex'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/disable',
    name: 'Disable',
    component: () => import('@/views/common/Disable'),
    meta: {
      requiresAuth: true
    }
  },

  

  /**
   * 线上服务
   */
  {
    path: '/onLineIndex',
    name: 'onLineIndex',
    component: () => import('@/views/home/onLine/OnLineIndex'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/addCard',
    name: 'AddCard',
    component: () => import('@/views/home/onLine/CardAdd'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/updateCard',
    name: 'UpdateCard',
    component: () => import('@/views/home/onLine/CardUpdate'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cardList',
    name: 'CardList',
    component: () => import('@/views/home/onLine/CardList'),
    meta: {
      requiresAuth: true
    }
  },

  /**
   * 线下服务
   */
  {
    path: '/offLineIndex',
    name: 'offLineIndex',
    component: () => import('@/views/home/offLine/OffLineIndex'),
    meta: {
      requiresAuth: true
    }
  },
  /**
   * 洗车
   */
  {
    path: '/washCar',
    name: 'WashCar',
    component: () => import('@/views/home/offLine/WashCar'),
    meta: {
      requiresAuth: true
    }
  },
  /**
   * 门店信息
   */
  {
    path: '/storeInfo',
    name: 'StoreInfo',
    component: () => import('@/views/home/offLine/StoreInfo'),
    meta: {
      requiresAuth: true
    }
  },
  /**
   * 卡券购买
   */
  {
    path: '/couponsBuy',
    name: 'CouponsBuy',
    component: () => import('@/views/home/offLine/CouponsBuy'),
    meta: {
      requiresAuth: true
    }
  },
  /**
   * 车辆安全检测
   */
  {
    path: '/carSatety',
    name: 'carSatety',
    component: () => import('@/views/home/offLine/CarSatety'),
    meta: {
      requiresAuth: true
    }
  },
  /**
   * 卡券
   */
  {
    path: '/coupons',
    name: 'Coupon',
    component: () => import('@/views/home/index/NewServerIndex'),
    meta: {
      requiresAuth: true
    }
  },
  /**
   * 核销
   */
  {
    path: '/showQRCode',
    name: 'ShowQRCode',
    component: () => import('@/views/home/offLine/ShowQRCode'),
    meta: {
      requiresAuth: true
    }
  },
  /**
   * 查看门店
   */
  {
    path: '/showStore',
    name: 'ShowStore',
    component: () => import('@/views/home/offLine/ShowStore'),
    meta: {
      requiresAuth: true
    }
  },
  /**
   * 个人中心
   */

  {
    path: '/address',
    name: 'address',
    component: () => import('@/views/person/AddressList'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/addAddress',
    name: 'AddAddress',
    component: () => import('@/views/person/AddressAdd'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/orders',
    name: 'orders',
    component: () => import('@/views/person/OrderList'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/watchVideo',
    name: 'watchVideo',
    component: () => import('@/views/person/WatchVideo'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/showVideo',
    name: 'showVideo',
    component: () => import('@/views/person/ShowVideo'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/videoDetail',
    name: 'videoDetail',
    component: () => import('@/views/person/VideoDetail'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/usedCoupons',
    name: 'usedCoupons',
    component: () => import('@/views/person/UsedCouponList'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/user',
    name: 'User',
    component: () => import('@/views/person/Index'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/recharge',
    name: 'recharge',
    component: () => import('@/views/person/Recharge'),
    meta: {
      requiresAuth: true
    }
  },
  /**
   * 批量绑定实体卡
   */
   {
    path: '/batchEntity',
    name: 'BatchEntity',
    component: () => import('@/views/person/BatchEntity'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/updatePhone',
    name: 'UpdatePhone',
    component: () => import('@/views/person/UpdatePhone'),
    meta: {
      requiresAuth: true
    }
  },
  /**
   * 注册
   */
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/common/Register'),
    meta: {
      requiresAuth: true
    }
  },
  /**
   * 修改手机号
   */
  {
    path: '/updateMobile',
    name: 'UpdateMobile',
    component: () => import('@/views/home/index/UpdateMobile'),
    meta: {
      requiresAuth: true
    }
  },
  /**
   * 通用子页面
   */
  {
    path: '/settleSuccess',
    name: 'SettleSuccess',
    component: () => import('@/views/common/Success'),
    meta: {
      requiresAuth: true
    }
  },
  /**
   * 客服
   */
   {
    path: '/customerServer',
    name: 'CustomerServer',
    component: () => import('@/views/person/customerService'),
    meta: {
      requiresAuth: true
    }
  },
  /**
   * 帮助反馈
   */
  {
    path: '/help',
    name: 'Help',
    component: () => import('@/views/home/index/Help'),
    meta: {
      requiresAuth: true
    }
  },
  /**
   * 添加车辆
   */
  {
    path: '/addCar',
    name: 'AddCar',
    component: () => import('@/views/home/onLine/AddCar')
  },
  /**
   * 预约线上年审
   */
  {
    path: '/onlineNs',
    name: 'OnlineNs',
    component: () => import('@/views/home/onLine/OnlineNs')
  },
  /**
   * 我的车辆列表
   */
  {
    path: '/carList',
    name: 'CarList',
    component: () => import('@/views/person/CarList')
  },
  {
    path: '/refunds',
    name: 'Refunds',
    component: () => import('@/views/person/Refund')
    // component: () => import('@/views/person/RefundMaintenance')
  },
  {
    path: '/paySucc',
    name: 'PaySucc',
    component: () => import('@/views/person/PaySucc')
  },
  {
    path: '/withdraw',
    name: 'Withdraw',
    component: () => import('@/views/withdraw/index')
  },
  {
    path: '/addBank',
    name: 'AddBank',
    component: () => import('@/views/home/onLine/AddBank')
  },
  
  {
    path: '/bankList',
    name: 'BankList',
    component: () => import('@/views/home/onLine/BankList'),
    meta: {
      requiresAuth: true,
      cache: true
    }
  },
  {
    path: '/accountList',
    name: 'AccountList',
    component: () => import('@/views/home/account/AccountList'),
    meta: {
      requiresAuth: true,
      cache: true
    }
  },
  {
    path: '/alipay-info',
    name: 'AlipayInfo',
    component: () => import('@/views/home/account/AlipayInfo'),
    meta: {
      requiresAuth: true,
      cache: true
    }
  },
  {
    path: '/bank-info',
    name: 'BankInfo',
    component: () => import('@/views/home/account/BankInfo'),
    meta: {
      requiresAuth: true,
      cache: true
    }
  },
  {
    path: '/wxpay-info',
    name: 'WxpayInfo',
    component: () => import('@/views/home/account/WxpayInfo'),
    meta: {
      requiresAuth: true,
      cache: true
    }
  },
  /**
   * 充值记录
   */
  {
    path: '/withdrawList',
    name: 'withdrawList',
    component: () => import('@/views/person/WithdrawList'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '*',
    name: '*',
    component: () => import('@/views/common/404')
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('@/views/test/Test')
  }
]